import { useNativeEvent } from './useNativeEvent';

/**
 * - Native에서 scrollToTop 이벤트를 수신하여 콜백을 실행합니다.
 * - 탭 클릭 또는 Top 버튼 클릭 시 호출됩니다.
 */
export const useNativeScrollToTop = ({
  instanceId,
  onScrollToTop,
}: {
  instanceId: string;
  onScrollToTop: () => void;
}) => {
  useNativeEvent('scrollToTop', instanceId, onScrollToTop);
};
